<script setup>
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";
import Button from "@/shared/ui/button/Button.vue";

defineProps({
  statementNotFound: {
    type: Boolean,
    default: false,
  },
  existingCaseFound: {
    type: Boolean,
    default: false,
  },
  checkResults: {
    type: Object,
    default: null,
  },
  isTestamentAuthor: {
    type: Boolean,
    default: false,
  },
});

defineEmits([
  "export-report",
  "show-existing-case-info",
  "show-statement-info",
  "show-notary-data",
  "attach-testament",
  "open-testament-document",
]);
</script>

<template>
  <div class="flex flex-col gap-4 w-full">
    <!-- Заявление не найдено -->
    <div
      v-if="statementNotFound"
      class="w-full p-4 rounded-md flex flex-col gap-3.5 bg-muted border border-border"
    >
      <div class="flex gap-2.5 items-center">
        <svg-icon
          name="huge-document-link"
          class="w-5 h-5 shrink-0 text-foreground mt-1"
        />
        <div class="flex flex-col gap-0.5">
          <p class="text-sm leading-5 text-foreground font-medium">
            {{ $t("Заявление не найдено.") }}
          </p>
          <p class="text-xs text-foreground leading-5">
            {{
              $t(
                "Необходимо прикрепить заявление для открытия наследственного дела"
              )
            }}
          </p>
        </div>
      </div>
    </div>

    <!-- Заявление найдено -->
    <div
      v-if="!statementNotFound && checkResults?.statement?.found"
      class="w-full p-4 rounded-md flex flex-col gap-3.5 bg-muted border border-border"
    >
      <div class="flex gap-2.5 items-center">
        <svg-icon
          name="huge-document-link"
          class="w-5 h-5 shrink-0 text-foreground mt-1"
        />
        <p class="text-sm leading-5 text-foreground font-medium">
          {{ $t("Заявление найдено") }}
        </p>
      </div>
      <div class="flex flex-wrap gap-2.5">
        <Button
          variant="outline"
          class="text-xs font-normal flex-1 min-w-fit"
          @click="$emit('show-statement-info')"
        >
          {{ $t("Показать информацию") }}
        </Button>
      </div>
    </div>

    <!-- Наличие открытого наследственного дела -->
    <div
      v-if="existingCaseFound"
      class="w-full p-4 rounded-md flex flex-col gap-3.5 bg-muted border border-border"
    >
      <div class="flex gap-2.5 items-center">
        <svg-icon
          name="huge-document-info"
          class="w-5 h-5 shrink-0 text-foreground mt-1"
        />
        <p class="text-sm leading-5 text-foreground font-medium">
          {{ $t("Наличие открытого наследственного дела") }}
        </p>
      </div>
      <div class="flex flex-wrap gap-2.5">
        <!--        <Button-->
        <!--          @click="$emit('export-report')"-->
        <!--          variant="default"-->
        <!--          class="text-xs font-normal flex-1 min-w-fit"-->
        <!--        >-->
        <!--          <svg-icon name="huge-upload" class="w-4 h-4" />-->

        <!--          {{ $t("Выгрузить справку") }}-->
        <!--        </Button>-->
        <Button
          variant="outline"
          class="text-xs font-normal flex-1 min-w-fit"
          @click="$emit('show-existing-case-info')"
        >
          {{ $t("Показать информацию") }}
        </Button>
      </div>
    </div>

    <!-- Найдено завещание -->
    <div
      v-if="checkResults?.testament?.found"
      class="w-full p-4 rounded-md flex flex-col gap-3.5 bg-muted border border-border"
    >
      <div class="flex justify-between items-center w-full">
        <div class="flex gap-2.5 items-center">
          <svg-icon
            name="huge-business-case"
            class="w-5 h-5 shrink-0 text-foreground"
          />
          <p class="text-sm leading-5 text-foreground font-medium">
            {{ $t("Найдено завещание") }}
          </p>
        </div>
      </div>
      <div class="flex flex-wrap gap-2.5 w-full">
        <Button
          v-if="isTestamentAuthor"
          variant="outline"
          class="gap-2 font-normal text-xs flex-1 min-w-fit"
          @click="$emit('open-testament-document')"
        >
          <svg-icon name="huge-file-attach" class="w-4 h-4" />
          {{ $t("Открыть документ") }}
        </Button>
        <Button
          v-else
          variant="default"
          class="gap-2 font-normal text-xs flex-1 min-w-fit"
          @click="$emit('attach-testament')"
        >
          <svg-icon
            name="huge-document-link"
            class="w-5 h-5 shrink-0 text-white"
          />
          {{ $t("Прикрепить") }}
        </Button>

        <Button
          variant="outline"
          class="text-xs font-normal flex gap-2 flex-1 min-w-fit"
          @click="$emit('show-notary-data')"
        >
          {{ $t("Показать информацию") }}
        </Button>
      </div>
    </div>

    <!-- Все проверки пройдены -->
    <div
      v-if="
        !statementNotFound &&
        !existingCaseFound &&
        !checkResults?.testament?.found
      "
      class="w-full p-4 rounded-md flex gap-2.5 items-center bg-muted border border-border"
    >
      <svg-icon
        name="huge-check-mark"
        class="w-5 h-5 shrink-0 text-green-600"
      />
      <p class="text-xs leading-6 text-foreground font-medium">
        {{ $t("Все проверки успешно пройдены") }}
      </p>
    </div>
  </div>
</template>
